export const formatCurrency = (
  amount: number | string | undefined,
): string => {
  if (amount === undefined) return '';

  const numericValue =
    typeof amount === 'number' ? amount : Number(amount);

  if (Number.isNaN(numericValue)) {
    return String(amount);
  }

  return new Intl.NumberFormat('ru-RU', {
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numericValue);
};
